module.exports = __webpack_public_path__ + "img/event-slider-2.57b831ae.jpg";